import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// Schema
//import { newCommunicationSchema } from '../../../../components/forms/NewCommunicationForm/schema';
import { selectCommunicationOrderByIdOrder } from '../../../../../gql/selectors/communications';

// GraphQL
import { client } from '../../../../../gql/client';

const loadCommunicationSummary = async (idOrder: string) => {
  try {
    const orderCommunicationData = await selectCommunicationOrderByIdOrder(
      idOrder
    );

    return {
      ...orderCommunicationData,
      operator: `${orderCommunicationData?.userOperator.name} ${
        orderCommunicationData?.userOperator.surName.split(' ')[0]
      }`,
    };
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Communication Summary loading error:', err);
    return true;
  }
};

export const LoaderCommunicationDuplicateSummary: LoaderFunction = async ({
  params,
}) => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  if (!params.id) return null;
  if (Object.keys(client.cache.extract()).length === 0) return null;

  // As this is a Loader that communicates with an API, add the `defer` function to return data asynchronously
  // which combines with the Fallback component wrapping the page to show loaders properly
  const loaderToResolve = loadCommunicationSummary(params.id);
  return loaderToResolve;
};

  return { data: load() };
};
